import { render, staticRenderFns } from "./Dialog_UpdateClass_Semester.vue?vue&type=template&id=85a69dea&"
import script from "./Dialog_UpdateClass_Semester.vue?vue&type=script&lang=js&"
export * from "./Dialog_UpdateClass_Semester.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_UpdateClass_Semester.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports